var map = {
	"./01.svg": 588,
	"./02.svg": 589,
	"./03.svg": 590,
	"./04.svg": 591,
	"./05.svg": 592,
	"./06.svg": 593,
	"./07.svg": 594,
	"./08.svg": 595,
	"./09.svg": 596,
	"./10.svg": 597,
	"./11.svg": 598,
	"./12.svg": 599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 587;